import i18n from "i18n-js";
import memoize from "lodash.memoize"; // Use for caching/memoize for better performance

export const translate = memoize(
  (key, config) => i18n.t(key, config),
  (key, config) => (config ? key + JSON.stringify(config) : key)
);

export const setI18nConfig = () => {
  // clear translation cache
  translate.cache.clear();
  // set i18n-js config
  i18n.translations = {
    en: require("../constants/strings/en"),
    fr: require("../constants/strings/fr"),
  };
  i18n.locale = "en";
};
